import { z } from 'zod';

/**
 * Wire schemas for photo API responses
 * These match the backend response format (snake_case)
 */

/**
 * Check-in photo wire schema (matches backend response format)
 * Based on CheckInPhotoReadSchema from Gateway
 */
export const photoWireSchema = z.object({
  id: z.string(),
  check_in_id: z.string(),
  r2_key: z.string(),
  image_url: z.string().url(),
  created_at: z.string(), // D1 DATETIME (ISO format)
});

export type PhotoWire = z.infer<typeof photoWireSchema>;

/**
 * Photo upload response schema
 */
export const photoUploadResponseSchema = photoWireSchema;

export type PhotoUploadResponse = z.infer<typeof photoUploadResponseSchema>;
